<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      碧头站<br>
站点介绍<br>
碧头站位于郎碧路与松福大道交界处，沿郎碧路呈南北走向，该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:17	23:36	11号线	4分钟	6分32秒<br>
碧头	--	--	11号线	4分钟	6分32秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:17	23:36	11号线	4分34秒	6分钟<br>
碧头	--	--	11号线	4分34秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
岗厦北	06:17	23:36	11号线	4分37秒	6分钟<br>
碧头	--	--	11号线	4分37秒	6分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
朗碧路西侧、松岗车辆段<br><br>
B出入口:<br>
朗碧路西侧<br><br>
C出入口:<br>
松福大道北侧、朗碧路东侧、满京华云著、优扬科技园<br><br>
D出入口:<br>
朗碧路东侧、浦京半导体产业园、锦江之星品尚酒店<br><br>
E出入口:<br>
朗碧路东侧、洋涌工业路南侧、沙浦围创业工业区<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 碧头地铁站北<br>
东莞216、东莞285<br><br>
C出入口:<br>
公交站名： 碧头地铁站<br>
656、M495<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiyihaoxian",
            title: "11号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>